"use strict";

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownUserDefinedTypeError = void 0;
/**
 * This error indicates that the decoder was unable to locate a user-defined
 * type (struct, enum, or contract type) via its ID.  Unfortunately, we can't
 * always avoid this at the moment; we're hoping to make this more robust in
 * the future with Truffle DB.  In the meantime, it is at least worth noting that
 * you should not encounter this error if your entire project was written in
 * Solidity and all compiled at once.  Sorry.
 *
 * @Category Errors
 */

var UnknownUserDefinedTypeError = /*#__PURE__*/function (_Error) {
  _inherits(UnknownUserDefinedTypeError, _Error);

  var _super = _createSuper(UnknownUserDefinedTypeError);

  function UnknownUserDefinedTypeError(id, typeString) {
    var _this;

    _classCallCheck(this, UnknownUserDefinedTypeError);

    var message = "Cannot locate definition for ".concat(typeString, " (ID ").concat(id, ")");
    _this = _super.call(this, message);
    _this.name = "UnknownUserDefinedTypeError";
    _this.id = id;
    _this.typeString = typeString;
    return _this;
  }

  return _createClass(UnknownUserDefinedTypeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.UnknownUserDefinedTypeError = UnknownUserDefinedTypeError;